"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { sync: constants_1.SyncConfig.DEFAULT, order: constants_1.OrderConfig.BOTTOM };
//# sourceMappingURL=constants.js.map